{
  "title": "Apps",
  "intro": "Software CloudServer installs and runs on your servers or in its own infrastructure. Every change is a revision you can roll back to; manual edits of its files show as drift.",
  "tabsLabel": "Apps sections",
  "tabs": {
    "catalogue": "Catalogue",
    "installed": "Installed"
  },
  "catalogue": {
    "label": "App catalogue",
    "emptyTitle": "The catalogue is empty",
    "emptyText": "There are no apps on this installation yet.",
    "install": "Install",
    "installAria": "Install «{{name}}»",
    "installed": "Installed: {{count}}",
    "free": "Free",
    "perMonth": "{{price}} a month",
    "unavailable": {
      "bundle_missing": "Not available: no signed bundle on this installation.",
      "bundle_unverified": "Not available: the bundle's signature does not verify.",
      "no_provider_plane": "Not available: it needs CloudServer's infrastructure, which is not connected yet.",
      "driver_not_built": "Coming in a later stage.",
      "no_autopilot": "Unavailable: the appliance needs Autopilot, which is not set up on this installation."
    },
    "freePlusServers": "Free + servers at the provider's prices"
  },
  "placement": {
    "provider": "In CloudServer's infrastructure",
    "customer-vm": "On your server",
    "customer-appliance": "Managed appliance in the project",
    "hybrid": "Hybrid"
  },
  "category": {
    "core": "Core",
    "network": "Networking",
    "vpn": "VPN",
    "apps": "Apps",
    "monitoring": "Monitoring",
    "dns": "DNS and domains",
    "provider_service": "CloudServer service",
    "example": "Example"
  },
  "installed": {
    "label": "Installed apps",
    "emptyTitle": "Nothing installed",
    "emptyText": "Choose an app in the catalogue: CloudServer installs it on a server through the Autopilot role and keeps an eye on its files.",
    "toCatalogue": "Open the catalogue",
    "columns": {
      "name": "App",
      "where": "Where",
      "state": "State",
      "revision": "Revision",
      "ownership": "Managed by",
      "autonomy": "Autopilot"
    },
    "plane": "CloudServer's infrastructure",
    "revision": "{{applied}} of {{desired}}",
    "notApplied": "not applied",
    "appliance": "Its own server: {{server}}"
  },
  "phase": {
    "pending": "Pending",
    "applying": "Applying",
    "ready": "Running",
    "drift": "Changed by hand",
    "error": "Error",
    "removing": "Removing"
  },
  "ownership": {
    "managed": "CloudServer",
    "co-managed": "Together",
    "customer": "You"
  },
  "ownershipHint": {
    "managed": "The panel is the source of truth. Manual edits of the app's files are drift: you see them and can put them back.",
    "co-managed": "The panel runs only its own files and fields; the rest is yours.",
    "customer": "You are the source of truth. Autopilot only watches and proposes; it changes things only through your card."
  },
  "autonomy": {
    "observe": "Observes",
    "suggest": "Suggests",
    "approve": "Acts after approval",
    "policy": "Acts within policy"
  },
  "autonomyHint": {
    "observe": "Only notes drift in the journal.",
    "suggest": "Proposes a change as a card; you apply it yourself.",
    "approve": "Prepares a change and runs it once you approve the card.",
    "policy": "Fixes what the policy allows by itself (e.g. puts its own files back after a manual edit). With a terminal open on the server it still asks."
  },
  "autonomySource": {
    "instance": "set for the app",
    "project": "as in the project",
    "organization": "as in the organisation",
    "package": "the default"
  },
  "projectAutonomy": {
    "label": "Autopilot's autonomy in the project",
    "inherit": "As in the organisation",
    "saved": "The project's autonomy is saved"
  },
  "reasons": {
    "applied": "Revision applied",
    "previous_revision": "The previous revision runs",
    "not_applied": "Revision not applied",
    "in_sync": "Files match",
    "no_error": "No errors",
    "manual_edit": "Changed by hand",
    "customer_change": "Files changed by you",
    "verify_failed": "Checks failed, change rolled back",
    "foreign_files": "Someone else's file at a path",
    "helper_refused": "The helper on the server refused",
    "not_installed": "Not installed on the server",
    "server_state_missing": "The app's state on the server is gone",
    "plane_failed": "The service was not built",
    "ready": "The service is ready",
    "provisioning": "The service is being built",
    "frozen": "Hands off: Autopilot changed nothing",
    "observe_only": "Autopilot only observes",
    "presence": "A terminal is open on the server",
    "autonomy": "The autonomy says so",
    "ownership": "You run this app",
    "customer_file": "It is a customer's file",
    "changed_since_card": "The file changed after the card was made",
    "plan_changed": "The change is no longer the one on the card",
    "unsupported": "The panel cannot edit this file",
    "not_in_bundle": "The app does not change this file",
    "requires_os": "The server's release is older than the app works with",
    "requires_arch": "The server's architecture is not supported",
    "requires_repository": "The app's repository does not support the server's release or architecture",
    "requires_repository_reachable": "The app's repository did not answer — try again later",
    "requires_no_docker": "The server has Docker installed outside the panel",
    "requires_no_docker_repo": "The server has Docker's repository added outside the panel",
    "requires_unmet": "The server does not suit the app",
    "package_not_applied": "The app is not applied on the server yet",
    "not_managed": "Not the panel's container: yours have their own action",
    "listing_changed": "The list of images changed: check again",
    "engine_stopped": "Docker is stopped",
    "engine_removed": "Docker was removed from the server",
    "no_container": "No such container",
    "container_invalid": "Not a valid container name",
    "restart_failed": "The restart failed",
    "restart_rolled_back": "The service did not come back after the restart: the file was put back and the service restarted again",
    "op_failed": "The action failed",
    "unknown_action": "The server does not know this action",
    "remove_failed": "Removing failed; the files stay",
    "purge_failed": "The data could not be deleted",
    "no_restart_step": "The app has no restart step",
    "engine_not_running": "Docker did not come up",
    "resources_creating": "The appliance's resources are being created",
    "resources_deleting": "The appliance's resources are being deleted",
    "rolled_back": "What was created is deleted",
    "enrolment_timeout": "The helper on the new server never answered",
    "protection_failed": "The server's protection could not be turned on",
    "server_gone": "The server is gone at the provider",
    "resource_failed": "A resource was not created",
    "appliance_changed": "Changed at the provider",
    "managed_appliance": "A managed appliance: it changes only through its app",
    "take_over_unsupported": "Only the server the app runs on can be taken over",
    "appliance_not_ready": "The appliance is not ready yet",
    "bad_key": "The helper did not accept the key",
    "prefix": {
      "provider": "The provider refused ({{reason}})",
      "bundle": "The app did not install on the server: {{reason}}",
      "delete": "Deleting did not go through: {{reason}}"
    }
  },
  "checks": {
    "package_version": "Docker's version",
    "service_disabled": "the docker service's autostart",
    "engine_removed": "Docker (removed)",
    "tailscale": {
      "service_disabled": "the tailscaled service's start on boot",
      "logged_out": "the node logged out of Tailscale",
      "tailscale_down": "Tailscale stopped (tailscale down)",
      "routes_changed": "the advertised subnets",
      "exit_node_changed": "the exit node",
      "ssh_changed": "Tailscale SSH",
      "forwarding_off": "IP forwarding",
      "tailscale_removed": "Tailscale (removed)"
    }
  },
  "problems": {
    "required": "Fill this in.",
    "type": "The value has the wrong type.",
    "enum": "Choose one of the options.",
    "min_length": "At least {{limit}} characters.",
    "max_length": "At most {{limit}} characters.",
    "pattern": "Characters that are not allowed.",
    "minimum": "At least {{limit}}.",
    "maximum": "At most {{limit}}.",
    "max_items": "At most {{limit}} lines.",
    "unknown": "The app has no such field."
  },
  "form": {
    "secretStored": "Saved. Leave empty to keep it.",
    "listHint": "One value per line.",
    "labelsHint": "Comma-separated: key=value.",
    "choose": "Choose…",
    "ranges": {
      "label": "CIDR range",
      "add": "Add",
      "addManual": "Add a range by hand",
      "manual": "Ranges added by hand",
      "remove": "Remove {{range}}",
      "invalid": "This is not a CIDR range, for example 192.168.10.0/24."
    }
  },
  "wizard": {
    "title": "Install: {{name}}",
    "stepsLabel": "Install steps",
    "step": "Step {{n}} of {{total}}",
    "next": "Next",
    "back": "Back",
    "install": "Install",
    "steps": {
      "connect": "Connect",
      "inputs": "Settings",
      "server": "Server",
      "review": "Review",
      "resources": "Resources and cost"
    },
    "oauth": "Sign in to {{provider}}",
    "oauthSoon": "Signing in with a third-party account comes with the first apps that need it. The tokens will be kept by us, encrypted.",
    "deviceSoon": "Confirming with a device code comes with the first apps that need it.",
    "serverLead": "The app is installed through Autopilot's «App management»: the helper on the server accepts only bundles we signed and writes only its own files.",
    "serverLabel": "Server",
    "roleMissing": "Needs «App management»",
    "notRunning": "The server is off",
    "installedHere": "Installed already",
    "releaseUnsupported": "The app does not support {{release}}",
    "repositoryUnavailable": "{{name}}'s repository does not support {{release}}",
    "releaseUntested": "The repository supports {{release}}; we have not verified this release yet",
    "releaseUnchecked": "The release is checked on the server before installing",
    "setRole": "Turn the role on in the «Autopilot» tab",
    "noServers": "No server of the project has «App management» turned on. Turn it on in a server's «Autopilot» tab and run the role command on the server.",
    "ownershipLegend": "Who runs the app",
    "review": {
      "inputs": "Settings",
      "server": "Server",
      "where": "Where",
      "price": "Price",
      "priceNote": "Apps are not billed yet: only usage is recorded.",
      "secret": "hidden",
      "connect": "Connection",
      "appliance": "A new server in the project — a managed appliance ({{names}})",
      "resources": "Servers at the provider",
      "resourcesNote": "The provider bills the appliance's server like any of your servers; in the costs it is listed under this app."
    },
    "done": "«{{name}}» is installed",
    "stopped": "The installation stopped",
    "provisioning": "«{{name}}»: creating the appliance's server — this takes a few minutes",
    "noNetworks": {
      "text": "The project has no private network, so the appliance has nothing to open. Create a network, or install the app as a client on a server.",
      "create": "Create a network",
      "asClient": "Install as a client on a server"
    }
  },
  "instance": {
    "back": "All apps",
    "tabsLabel": "App sections",
    "tabs": {
      "state": "State",
      "revisions": "Revisions",
      "journal": "Journal",
      "settings": "Settings"
    },
    "on": "on {{server}}",
    "check": "Check",
    "checked": "Files checked",
    "managedNotice": "CloudServer runs this app's files. Manual changes are found and shown as drift.",
    "applianceNotice": "Managed appliance. Manual changes will be overwritten.",
    "frozen": "Hands off: Autopilot changes nothing in this app. Your own changes still run.",
    "serverFrozen": "Hands off on the server: Autopilot changes nothing there.",
    "lease": "Autopilot is changing {{name}}, about {{minutes}} min left",
    "leaseBy": "A change of {{name}} runs: {{verb}}",
    "presence": "A terminal is open on the server (people: {{count}}): Autopilot's changes wait for a card.",
    "drift": {
      "title": "Changed by hand",
      "text": "Someone changed by hand on the server: {{files}}. Changes from the panel stopped so as not to overwrite the edit.",
      "revert": "Put it back",
      "reverted": "Put back"
    },
    "customerChange": "Files differ from the panel: {{files}}. You run this app: this is your state.",
    "error": "The last change did not apply: {{reason}}",
    "stopped": "The change stopped: {{reason}}",
    "proposals": {
      "title": "Autopilot proposes",
      "revert": "Put back as it was: {{files}}",
      "apply": "Apply revision {{revision}}",
      "why": "Why a card: {{reason}}",
      "approve": "Approve",
      "reject": "Reject",
      "approved": "Card approved",
      "rejected": "Card rejected",
      "patch": "Change the file {{path}}",
      "patchHow": "This is your file: Autopilot changes it only through this card. When you press the button it keeps a copy of the file, makes exactly this change, checks the result and puts the copy back if the check fails. If the file changes first, the change is not made — a new card appears.",
      "created": "The file does not exist yet — it will be created.",
      "tooBig": "The file is too big to show the change here (over 32 KB).",
      "diffLabel": "Change of the file {{path}}",
      "unchanged": "… unchanged lines: {{count}}",
      "applyPatch": "Apply the change",
      "applyRestart": "Apply and restart",
      "applyNoRestart": "Apply without a restart ({{later}})",
      "restartNotice": "The service restarts to read the file.",
      "restartRollback": "If the service does not come back after the restart, Autopilot puts the copy of the file back and restarts it again.",
      "appliedRestarted": "Change applied, service restarted",
      "appliedLater": "Change applied; takes effect at the next start"
    },
    "widgets": {
      "empty": "The server has not reported the state yet.",
      "noValue": "—"
    },
    "files": {
      "title": "Files on the server",
      "checked": "checked {{time}}",
      "never": "not checked yet",
      "states": {
        "ok": "matches",
        "drift": "changed",
        "missing": "deleted",
        "unknown": "unknown"
      }
    },
    "outputs": "Outputs",
    "conditions": "Conditions",
    "actions": {
      "run": "Run",
      "confirm": "Run «{{name}}»?",
      "done": "«{{name}}» done"
    },
    "revisions": {
      "label": "Revisions",
      "columns": {
        "number": "No.",
        "reason": "What",
        "state": "Result",
        "actor": "Who",
        "when": "When"
      },
      "reasons": {
        "install": "Install",
        "configure": "Settings",
        "action": "Action «{{detail}}»",
        "rollback": "Rollback to revision {{detail}}",
        "revert": "Put back after a manual edit"
      },
      "states": {
        "pending": "Pending",
        "applied": "Applied",
        "failed": "Not applied",
        "rolled_back": "Rolled back",
        "superseded": "Superseded",
        "proposed": "Proposed"
      },
      "rollback": "Roll back",
      "rollbackAria": "Roll back to revision {{number}}",
      "rollbackTitle": "Roll back to revision {{number}}?",
      "rollbackText": "A new revision with the settings of revision {{number}} is made and applied on the server. Secrets stay as they are now.",
      "rolledBack": "Rollback applied",
      "current": "current"
    },
    "journal": {
      "label": "Change journal",
      "empty": "No entries yet.",
      "verbs": {
        "install": "install",
        "configure": "settings",
        "action": "action",
        "rollback": "rollback",
        "revert": "files put back",
        "remove": "remove",
        "check": "check",
        "drift": "manual edit",
        "freeze": "hands off",
        "unfreeze": "hands off lifted",
        "autonomy": "autonomy",
        "proposal": "card",
        "approve": "card approved",
        "reject": "card rejected",
        "patch": "customer's file changed",
        "adopt": "file handed over to the panel",
        "release": "file given back",
        "provision": "resource created",
        "deprovision": "resources deleted",
        "take_over": "taken over",
        "restore": "appliance put back"
      },
      "outcomes": {
        "success": "done",
        "failed": "failed",
        "refused": "stopped",
        "pending": "waiting"
      },
      "actors": {
        "person": "A person in the panel",
        "api_key": "API key",
        "assistant": "Assistant",
        "autopilot": "Autopilot",
        "ssh": "Someone over SSH",
        "provider": "Someone at the provider"
      },
      "revision": "revision {{revision}}"
    },
    "settings": {
      "configure": "Settings",
      "save": "Save and apply",
      "saved": "New revision applied",
      "ownership": "Who runs the app",
      "autonomy": "Autopilot's autonomy",
      "autonomyInherit": "As in the project",
      "autonomyAdmins": "Administrators can change the autonomy.",
      "autonomySaved": "Autonomy saved",
      "freeze": "Hands off",
      "freezeHint": "Autopilot changes nothing in this app, not even within policy. Your own changes still run.",
      "frozen": "Hands off is on",
      "unfrozen": "Hands off is off",
      "remove": "Remove the app",
      "removeText": "The app's files are removed from the server. The change journal is kept.",
      "removeButton": "Remove",
      "removeOverwrite": "Remove files changed by hand too",
      "removed": "«{{name}}» removed",
      "removeData": "Delete the app's data too",
      "removeDataWarning": "The app's data will be deleted for good."
    },
    "customerFiles": {
      "title": "Customer's files",
      "lead": "Files the app needs that belong to you: they have no directory for drop-ins. While a file is yours, Autopilot changes it only through a card. A file handed over to the panel is kept by the app itself: it keeps its keys in it and treats a manual edit of them as drift, while the rest of the file stays yours.",
      "states": {
        "pending": "change pending",
        "ok": "change in place",
        "changed": "changed by you",
        "drift": "the app's keys edited by hand",
        "missing": "file missing",
        "unsupported": "the panel cannot edit it",
        "unknown": "not checked yet",
        "off": "not used: turned off in the settings"
      },
      "adopted": "kept by the panel",
      "customers": "your file",
      "adopt": "Hand the file over to the panel",
      "release": "Take the file back",
      "adoptedDone": "The file is handed over to the panel",
      "released": "The file is yours again"
    }
  },
  "server": {
    "title": "Apps on the server",
    "lead": "What CloudServer installed on this server. The helper of «App management» writes only its own files and stops when they were changed by hand.",
    "none": "No apps on this server.",
    "install": "Install an app",
    "roleMissing": "To install apps, turn on «App management» in the «Autopilot» tab.",
    "freeze": "Hands off the whole server",
    "freezeHint": "Autopilot changes nothing on this server.",
    "frozen": "Hands off is on for the server",
    "unfrozen": "Hands off is off for the server",
    "appMissing": "This app is not on the server.",
    "openApp": "Open the app"
  },
  "docker": {
    "noStatus": "Docker's state has not been read yet. Press «Check».",
    "stopped": "Docker is stopped",
    "stoppedText": "No container runs on this server. The docker service's journal on the «Autopilot» tab tells why; common causes are a full disk and an error in /etc/docker/daemon.json.",
    "restartEngine": "Restart Docker",
    "restartEngineLead": "The Docker service restarts. Containers stop for a minute; those with a restart policy come back on their own.",
    "engineRestarted": "Docker restarted",
    "rootWarning": "A member of the docker group effectively has root on this server. Add only people you would trust with root.",
    "rootWarningUsers": "In the docker group: {{users}}. Each of them effectively has root on this server.",
    "owner": {
      "managed": "the panel's",
      "customer": "yours"
    },
    "state": {
      "running": "running",
      "restarting": "restarting",
      "exited": "stopped",
      "created": "created",
      "paused": "paused",
      "dead": "dead"
    },
    "containers": {
      "title": "Containers",
      "lead": "The panel runs its own containers (label cloudserver.managed=true). Yours it only shows, and touches only when you confirm.",
      "none": "No containers.",
      "engineDown": "Docker is not running: no containers to show.",
      "columns": {
        "name": "Container",
        "state": "State",
        "image": "Image",
        "status": "Status",
        "ports": "Ports"
      },
      "logs": "Log",
      "restart": "Restart",
      "restartCustomer": "Restart your container",
      "more": "The first 50 are shown; {{count}} more with «Show all».",
      "showAll": "Show all ({{count}})"
    },
    "logs": {
      "title": "Log: {{name}}",
      "lead": "The last lines. Passwords, tokens and keys in them are hidden.",
      "empty": "The log is empty."
    },
    "restart": {
      "title": "Restart {{name}}?",
      "lead": "The panel's container restarts and does not answer meanwhile.",
      "customer": "This is your container: the panel does not run it and restarts it only when you confirm.",
      "downtime": "The container does not answer while it restarts.",
      "done": "{{name}} restarted"
    },
    "images": {
      "title": "Unused images",
      "lead": "Images no container uses: {{count}}.",
      "none": "Every image is used by a container.",
      "prune": "Delete unused images",
      "pruneTitle": "Delete the unused images ({{count}})?",
      "pruneCustomer": "Your images go too: everything no container uses. To get them back they have to be pulled or built again.",
      "pruneExact": "Exactly the images listed below go. If the list on the server has changed, nothing is deleted.",
      "whatGoes": "What goes",
      "andMore": "and {{count}} more",
      "pruned": "Images deleted: {{count}}"
    },
    "logsPending": "The log settings are not in effect yet",
    "logsPendingText": "Log rotation is written to /etc/docker/daemon.json ({{size}}, files: {{files}}), but Docker has not restarted since and runs with its old settings. They take effect the next time Docker starts or after a restart — which stops the running containers without live-restore ({{count}}). They apply to new containers only."
  },
  "connect": {
    "legend": "How to connect",
    "kinds": {
      "secret": "Paste a key created in the console",
      "oauth": "The panel mints a key with the organisation's OAuth client",
      "device-login": "Sign in with a link after the install"
    },
    "deviceAfter": "After the install a sign-in link appears on the app's page. Open it and sign in — the panel sees the server join by itself.",
    "connection": "The organisation's connection",
    "noConnections": "The organisation has no connections yet. Ask an administrator to add a Tailscale OAuth client.",
    "noConnectionsAdmin": "The organisation has no connections yet. Add a Tailscale OAuth client.",
    "failing": "the last call failed",
    "requiredInputs": "With this method fill in: {{inputs}}.",
    "add": "Add a connection",
    "addTitle": "New Tailscale connection",
    "addLead": "The tailnet's administrator creates the OAuth client in the Tailscale console: Settings → OAuth clients, scopes auth_keys and devices:core. The panel checks it and keeps it encrypted; the secret is never shown again.",
    "addSubmit": "Check and save",
    "name": "Name",
    "clientId": "Client ID",
    "clientSecret": "Client secret",
    "clientSecretHint": "Starts with tskey-client-. Kept encrypted.",
    "loginTitle": "Sign-in",
    "loginLead": "The server waits for you to sign in with a link.",
    "loginIdle": "Get the sign-in link. Do not pass it on: whoever signs in with it first gets the server into their tailnet.",
    "getLink": "Get the sign-in link",
    "openAndSignIn": "Open the link and sign in",
    "linkSecret": "The link is for you only: do not pass it on.",
    "waiting": "Waiting for the sign-in…",
    "expired": "Time is up: the sign-in did not finish. Get a new link.",
    "newLink": "Get a new link",
    "noLink": "The server gave no link. Press «Check» and try again."
  },
  "tailscale": {
    "noStatus": "Tailscale's state is not read yet. Press «Check».",
    "states": {
      "running": "Connected",
      "starting": "Connecting",
      "needs_login": "Needs a sign-in",
      "needs_approval": "Waits for approval",
      "stopped": "Stopped by hand",
      "absent": "Not installed",
      "unknown": "Not answering"
    },
    "tailnet": "Tailnet {{name}}",
    "reconnect": "Reconnect",
    "logout": "Log out of Tailscale",
    "signedOut": "The server left the tailnet",
    "loginErrors": {
      "auth_key_expired": "The auth key expired",
      "auth_key_invalid": "The auth key did not work: wrong or used already",
      "login_failed": "Signing in to Tailscale failed"
    },
    "reconnectOauth": "Press «Reconnect» — the panel mints a new key with the OAuth client.",
    "reconnectKey": "Create a new key in the Tailscale console and press «Reconnect» to paste it.",
    "keysPage": "Keys in the Tailscale console",
    "needsApproval": "The tailnet requires approving new devices: an administrator approves the server in the Tailscale console (Machines).",
    "stopped": "Someone ran tailscale down on the server. «Revert» connects it again.",
    "sshWarning": "Tailscale SSH is on: a second way into the server that bypasses your SSH keys and firewall. The tailnet's ACL rules decide who gets in.",
    "tagsPending": "New tags take effect on reconnect.",
    "routes": {
      "title": "Routes",
      "lead": "What the node advertises and what the tailnet's administrator approved.",
      "approved": "approved",
      "pending": "waits for approval",
      "exitNode": "Exit node",
      "howToApprove": "Approve them in the Tailscale admin console: Machines → this node → «…» → Edit route settings — tick the subnets and «Use as exit node». Or set autoApprovers in the tailnet policy.",
      "console": "Open Machines in the Tailscale console",
      "forwardingOff": "IP forwarding is off on the server: routes and the exit node do not work. «Revert» turns it on."
    },
    "logoutTitle": "Log out of Tailscale?",
    "logoutAccess": "Access to the server through Tailscale stops at once.",
    "logoutAgain": "Come back with «Reconnect» and a new key or link.",
    "loggedOut": "The server logged out of Tailscale",
    "reconnected": "Reconnected",
    "reconnectLead": {
      "secret": "Paste a new auth key from the Tailscale console.",
      "oauth": "The panel mints a new single-use key with the organisation's OAuth client and the node's tags.",
      "device-login": "The server starts signing in again; then get a new sign-in link."
    },
    "devices": {
      "title": "Tailnet devices",
      "lead": "As the organisation's OAuth client sees them: addresses, last seen, approved routes.",
      "show": "Show devices",
      "none": "No devices in the tailnet.",
      "self": "this server",
      "online": "online",
      "columns": {
        "name": "Name",
        "addresses": "Addresses",
        "os": "OS",
        "seen": "Last seen",
        "routes": "Subnets"
      }
    }
  },
  "resources": {
    "title": "Resources",
    "lead": "What the app created in your project at the provider. It costs {{monthly}} a month now.",
    "planning": "Working out what will be created…",
    "planLead": "The app creates a server in your project — a managed appliance: without your SSH key, with delete protection and with Autopilot to manage the app. The provider bills it like any of your servers.",
    "planLabel": "What will be created",
    "kinds": {
      "server": "Server",
      "firewall": "Firewall"
    },
    "ipv4": "IPv4",
    "free": "Free",
    "unpriced": "Price unknown",
    "price": "{{monthly}} a month · {{hourly}} an hour",
    "totalProvider": "Servers at the provider",
    "totalPackage": "The app itself",
    "unpricedNote": "Part of the resources has no price in the price list: counted as free.",
    "costNote": "Our estimate from the price list, net of VAT. Every started hour is billed, up to the monthly price.",
    "provisioning": "The appliance is being created: the server, delete protection, Autopilot, then the app itself. This usually takes a few minutes.",
    "removing": "The appliance is being removed: protection off, the server and its firewall deleted at the provider.",
    "rolledBack": "The install failed: {{reason}}. Everything it had created is deleted.",
    "noServerYet": "the appliance's server is being created",
    "applianceOf": "Managed appliance · {{title}}",
    "since": "since {{time}}",
    "states": {
      "planned": "waiting",
      "creating": "being created",
      "protecting": "protection turning on",
      "enrolling": "waiting for Autopilot",
      "ready": "running",
      "unprotecting": "protection turning off",
      "deleting": "being deleted",
      "deleted": "deleted",
      "failed": "failed",
      "released": "yours"
    },
    "drift": {
      "title": "Changed at the provider",
      "label": "Label {{expected}} removed or changed (now: {{actual}})",
      "protection": "Delete and rebuild protection is off (on: {{actual}})",
      "type": "Server type changed: {{actual}} instead of {{expected}}"
    },
    "restore": "Put back as it was",
    "restored": "The appliance is being put back as it was",
    "takeOver": "Take over",
    "takeOverTitle": "Take over {{name}}?",
    "takeOverKey": "Your SSH key is added for root on this server — through Autopilot.",
    "takeOverLabels": "The panel's labels and delete and rebuild protection come off; the server becomes an ordinary server of yours.",
    "takeOverSupport": "The panel stops managing this server: manual changes are no longer overwritten, and support for the appliance ends. This cannot be undone.",
    "takeOverCost": "The server keeps running and is billed as yours.",
    "takeOverKeyLabel": "Key to add",
    "takenOver": "{{name}} is yours now",
    "takenOverNotice": "This appliance was taken over: its server is yours now, the panel does not manage it.",
    "noKeys": "The project has no SSH keys.",
    "addKey": "Add a key",
    "removeServers": "The appliance's servers are deleted at the provider, with the data on them: {{names}}.",
    "removeCost": "Billing for them stops when they are deleted.",
    "removeStarted": "«{{name}}» is being removed together with its server"
  }
}
